import React from 'react';
import {inject, observer} from 'mobx-react';
import {Popover} from 'antd';
import {WeaTools, WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

import E9QuickSearchTypes from './E9QuickSearchTypes';
import E9QuickSearchRcmd from './E9QuickSearchRcmd';

@inject('portalThemeStore')
@observer
class E9QuickSearch extends React.Component {
    constructor(props) {
        super(props);
        this.onTypesVisibleChange = this.onTypesVisibleChange.bind(this);
        this.onRcmdVisibleChange = this.onRcmdVisibleChange.bind(this);
        this.onTypeSearch = this.onTypeSearch.bind(this);
        this.onRcmdSearch = this.onRcmdSearch.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentWillMount() {
        const {portalThemeStore} = this.props;
        portalThemeStore.getQuickSearchTypes();
    }

    render() {
        const {portalThemeStore, from} = this.props;
        const {langId, showQuickSearch, quickSearchTypesVisible, quickSearchTypesSelected, quickSearchRcmdVisible, quickSearchShowRcmd} = portalThemeStore;
        const {name:selectedName} = quickSearchTypesSelected;

        // 不显示快捷搜索
        if (!showQuickSearch) {
            return null;
        }

        return (
            <div className="e9header-quick-search">
                {
                    quickSearchShowRcmd ? (
                            <Popover
                                trigger="click"
                                placement="bottomLeft"
                                content={<E9QuickSearchRcmd onVisibleChange={this.onRcmdVisibleChange} onTypeSearch={this.onTypeSearch}/>}
                                overlayClassName="e9header-quick-search-rcmd-overlay"
                                visible={quickSearchRcmdVisible}
                                onVisibleChange={this.onRcmdVisibleChange}
                            >
                                <div></div>
                            </Popover>
                        ) : ''
                }
                <div className="e9header-quick-search-types" style={langId == '8' ? {width: '100px'} : {}}>
                    <Popover
                        trigger="click"
                        placement="bottomLeft"
                        content={<E9QuickSearchTypes onVisibleChange={this.onTypesVisibleChange}/>}
                        overlayClassName={`e9header-quick-search-types-overlay ${from == 'em7' ? 'em7-quick-search-types-overlay' : ''}`}
                        visible={quickSearchTypesVisible}
                        onVisibleChange={this.onTypesVisibleChange}
                    >
                        <div className="e9header-quick-search-type">
                            <span className="e9header-quick-search-types-name" style={langId == '8' ? {width: '80px'} : {}} title={selectedName}>{selectedName}</span>
                            <span className="e9header-quick-search-types-icon">
                                <i className="wevicon-quick-search-arrow"/>
                            </span>
                        </div>
                    </Popover>
                </div>
                <div className="e9header-quick-search-split"></div>
                <div className="e9header-quick-search-content">
                    <input id="e9header-quick-search-input" className="e9header-quick-search-input" placeholder={getLabel(84128, '请输入关键词搜索')} onClick={this.onRcmdSearch} onChange={this.onRcmdSearch} onKeyDown={this.handleKeyDown}/>
                </div>
                <div className="e9header-quick-search-icon" onClick={this.onTypeSearch}>
                    <i className="wevicon-quick-search-search"/>
                </div>
            </div>
        );
    }

    onTypesVisibleChange(visible) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onQuickSearchTypesVisibleChange(visible);

        const themeLayoutMask = document.getElementById('themeLayoutMask');
        if (visible) {
            themeLayoutMask.style.display = 'block';
        } else {
            themeLayoutMask.style.display = 'none';
        }
    }

    onRcmdVisibleChange(visible) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onQuickSearchRcmdVisibleChange(visible);

        const themeLayoutMask = document.getElementById('themeLayoutMask');
        if (visible) {
            themeLayoutMask.style.display = 'block';
        } else {
            themeLayoutMask.style.display = 'none';
        }
    }

    onTypeSearch() {
        const value = jQuery('#e9header-quick-search-input').val();
        this.onRcmdVisibleChange(false);

        const {portalThemeStore} = this.props;
        portalThemeStore.onQuickSearch({from: 'theme', value: value});
    }

    onRcmdSearch(e) {
        const value = e.target.value;

        const {portalThemeStore} = this.props;
        const {quickSearchShowRcmd} = portalThemeStore;

        if (quickSearchShowRcmd) {
            this.onRcmdVisibleChange(!!value);
            portalThemeStore.onRcmdSearch(value);
        }
    }

    handleKeyDown(e) {
        if (e.keyCode == 13) {
            this.onTypeSearch();
        }
    }
}

export default E9QuickSearch;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9QuickSearch.js